import React from "react";
import { smsAllowanceBarClass, smsAllowanceRemainingText } from "../../helpers/smsAllowance";
import local from "../../localization/strings";

// The allowance as a bar: what is left, filling from the left, so it reads like a battery and empties
// as texts go out. The same remaining-first reading the admin site list uses (SmsUsage), so a figure
// seen there and here means the same thing.
//
// The status is never colour alone — every caller puts a word or a figure beside it — and the bar
// itself is a progressbar for screen readers.
const SmsAllowanceMeter = ({ view, height = 6, className = "", style = {} }) => (
	<div className={`progress ${className}`} style={{ ...style, height }} role="progressbar" aria-label={local.TF_SmsAllowance} aria-valuenow={view.remaining} aria-valuemin={0} aria-valuemax={view.scale} aria-valuetext={smsAllowanceRemainingText(view)}>
		<div className={`progress-bar ${smsAllowanceBarClass(view.status)}`} style={{ width: `${view.percentLeft}%`, height }} />
	</div>
);

export default SmsAllowanceMeter;
